import { modelMeasures } from "../../consts/misc";
import useIsMobile from "../../hooks/useIsMobile";

const ModelSpecsBar = (props: any) => {
  const { isMobile } = useIsMobile();
  const renderSpecs = modelMeasures.map((spec: any, key: number) => {
    return (
      <div
        key={key}
        className="model-details-card-info-spec-box"
        style={{ margin: isMobile ? "0 auto" : "30px 19px" }}
      >
        <p className="model-details-card-info-spec-field">{spec.displayName}</p>
        <p
          className="model-details-card-info-spec-value"
          style={{ width: "60px" }}
        >
          {`${props.model?.measures[spec.name]} ${
            spec.name === "hair" || spec.name === "eyes"|| spec.name === "shoes" ? "" : "cm"
          }`}
        </p>
      </div>
    );
  });

  return (
    <div
      className="model-specs-bar shadow"
      style={{
        width: isMobile ? "345px" : "",
        height: isMobile ? "290px" : "",
        display: isMobile ? "grid" : "flex",
        gridTemplateColumns: "1fr 1fr",
        padding: isMobile ? "15px 0" : "", 
      }}
    >
      {renderSpecs}
    </div>
  );
};
export default ModelSpecsBar;
